import React, { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react'
import { IconCheckBold } from '../../icons/IconCheckBold'
import clsx from 'clsx'

export interface IBpCheckbox extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | JSX.Element
  theme?: 'default' | 'grey'
}

export const BpCheckbox = forwardRef((props: IBpCheckbox, ref: ForwardedRef<HTMLInputElement>) => {
  const { label = '', theme = 'default', hidden, type = 'checkbox', ...inputProps } = props

  return (
    <label
      className={`group table ${!inputProps.disabled && 'cursor-pointer'} ${
        hidden ? 'invisible' : 'visible'
      }`}
    >
      <div className='flex items-center gap-[8px]'>
        <input {...inputProps} ref={ref} hidden className='peer' type={type}></input>
        <div
          className={clsx(
            'peer-disabled:bg-gray-700 flex h-[16px] w-[16px] items-center justify-center bg-white shadow-outline peer-checked:shadow-none peer-disabled:shadow-focus-500/[0.35] peer-disabled:peer-checked:bg-aqua-300/[0.40]',
            type === 'checkbox' ? 'rounded-[4px]' : 'rounded-full',
            theme === 'default'
              ? 'shadow-focus group-hover:shadow-default peer-checked:bg-default'
              : 'shadow-[#8E7CA7] group-hover:shadow-[#8E7CA7] peer-checked:bg-[#8E7CA7]',
          )}
        >
          {type == 'checkbox' ? (
            <span className='w-[9px]'>
              <IconCheckBold></IconCheckBold>
            </span>
          ) : (
            <span className='h-[6px] w-[6px] rounded-full bg-white'></span>
          )}
        </div>
        {label && (
          <span
            className={clsx(
              'select-none text-[14px] leading-[16px] peer-disabled:text-aqua-300',
              theme === 'default' ? 'text-focus-500' : 'text-[#8E7CA7]',
            )}
          >
            {label}
          </span>
        )}
      </div>
    </label>
  )
})
